module.exports = __webpack_public_path__ + "static/media/janis-logo-base.0cc15e53.svg";